type Props = {
  value?: string | null;
};
export function InventoryStatusBadge({ value }: Props) {
  const status = value || "UNKNOWN";
  const key = status.toUpperCase();
  const tone =
    ["ACTIVE", "APPROVED", "ISSUED", "POSTED", "COMPLETED"].includes(key)
      ? "border-emerald-200 bg-emerald-50 text-emerald-700"
      : ["DRAFT", "PENDING_APPROVAL", "VALIDATED", "PARTIALLY_VALID"].includes(key)
        ? "border-amber-200 bg-amber-50 text-amber-700"
        : ["REJECTED", "CANCELLED", "INACTIVE", "DELETED", "FAILED"].includes(key)
          ? "border-red-200 bg-red-50 text-red-700"
          : "border-slate-200 bg-slate-50 text-slate-700";
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${tone}`}>
      {status.replaceAll("_", " ")}
    </span>
  );
}
